import { render, staticRenderFns } from "./ModalEndChat.vue?vue&type=template&id=2107b71a&"
import script from "./ModalEndChat.vue?vue&type=script&lang=js&"
export * from "./ModalEndChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports